<script lang="ts">
	import { cn } from '$lib/utils';
	import { WebsiteName } from '../../config';
</script>

<div
	role="img"
	aria-label={WebsiteName}
	class={cn(
		'aspect-square size-6',
		'flex flex-col items-center justify-center',
		'bg-primary text-primary-foreground',
		'-rotate-12 rounded font-bold',
		'text-xs',
		'[&_*]:mt-[-2px] [&_*]:leading-[0.85]',
		'p-[2px] ',
	)}
>
	<img src="/images/LogoWhite.png" alt={WebsiteName} />
	<!-- <span>MV</span> -->
</div>
